import { combineReducers } from 'redux';

import actionTypes from './actionTypes';
import defaults from './defaults';

const basicReducer = (state, action, actionType, payloadName) => {
    switch (action.type) {
        case actionType:
            return action.payload[payloadName];
        case actionTypes.HYDRATE_FILTER_VALUES:
            return action.payload[payloadName] || state;
        case actionTypes.RESET_ALL_FILTERS:
            return defaults[payloadName];
        case actionTypes.RESET_FILTER:
            return action.payload.key === payloadName ? action.payload.value || defaults[payloadName] : state;
        default:
            return state;
    }
};

/* Organized alphabetically */
const customFiltersReducer = (state = defaults.customFilters, action) => {
    return basicReducer(state, action, actionTypes.SET_CUSTOM_FILTERS, 'customFilters');
};

const playerSearchReducer = (state = defaults.playerSearch, action) => {
    return basicReducer(state, action, actionTypes.SET_PLAYER_SEARCH, 'playerSearch');
};

const playerNationalityReducer = (state = defaults.nationalityCode, action) => {
    return basicReducer(state, action, actionTypes.SET_PLAYER_NATIONALITY, 'nationalityCode');
};

const decisionReducer = (state = defaults.decision, action) => {
    return basicReducer(state, action, actionTypes.SET_DECISION, 'decision');
};

const dominantHandReducer = (state = defaults.shootsCatches, action) => {
    return basicReducer(state, action, actionTypes.SET_DOMINANT_HAND, 'shootsCatches');
};

const draftRoundReducer = (state = defaults.draftRound, action) => {
    return basicReducer(state, action, actionTypes.SET_DRAFT_ROUND, 'draftRound');
};

const draftYearReducer = (state = defaults.draftYear, action) => {
    return basicReducer(state, action, actionTypes.SET_DRAFT_YEAR, 'draftYear');
};

const experienceReducer = (state = defaults.isRookie, action) => {
    return basicReducer(state, action, actionTypes.SET_EXPERIENCE, 'isRookie');
};

const gameLocationReducer = (state = defaults.homeRoad, action) => {
    return basicReducer(state, action, actionTypes.SET_GAME_LOCATION, 'homeRoad');
};

const opponentReducer = (state = defaults.opponent, action) => {
    return basicReducer(state, action, actionTypes.SET_OPPONENT, 'opponent');
};

const stateOrProvinceReducer = (state = defaults.birthStateProvinceCode, action) => {
    return basicReducer(state, action, actionTypes.SET_STATE_OR_PROVINCE, 'birthStateProvinceCode');
};

const statusReducer = (state = defaults.status, action) => {
    return basicReducer(state, action, actionTypes.SET_STATUS, 'status');
};

const reducer = combineReducers({
    customFilters: customFiltersReducer,
    playerSearch: playerSearchReducer,
    nationalityCode: playerNationalityReducer,
    decision: decisionReducer,
    shootsCatches: dominantHandReducer,
    draftRound: draftRoundReducer,
    draftYear: draftYearReducer,
    isRookie: experienceReducer,
    homeRoad: gameLocationReducer,
    opponent: opponentReducer,
    birthStateProvinceCode: stateOrProvinceReducer,
    status: statusReducer,
});

export default reducer;
